import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { SelectedUserContext } from "../../../context/selecteduser.context";
import { manageItineraryEnquiry, sendItineraryEmail } from "../../../api/itinerary.api";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { splitDate } from "../../../utils/splitDate";
import SnackbarContext from "../../../context/snackbar.context";
import CustomButton from "../../CustomButton/CustomButton";
import dayjs from "dayjs";
import "./style.scss";

interface IPreviewItineraryModal {
  previewData: any;
  handleSuccessModal: () => void;
  handleDetailsModal: () => void;
  setStepNumber: Dispatch<SetStateAction<number>>;
}

const svgFiles = {
  svg1: (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.94487 20C1.41003 20 0.952985 19.8 0.573736 19.41C0.194487 19.02 0 18.55 0 18V4C0 3.45 0.194487 2.98 0.573736 2.59C0.952985 2.2 1.41003 2 1.94487 2H2.9173V0H4.86217V2H12.6416V0H14.5865V2H15.5589C16.0938 2 16.5508 2.2 16.9301 2.59C17.3093 2.98 17.5038 3.45 17.5038 4V18C17.5038 18.55 17.3093 19.02 16.9301 19.41C16.5508 19.8 16.0938 20 15.5589 20H1.94487ZM1.94487 18H15.5589V8H1.94487V18ZM1.94487 6H15.5589V4H1.94487V6ZM8.7519 12C8.47962 12 8.24623 11.9 8.06147 11.71C7.87671 11.52 7.77947 11.28 7.77947 11C7.77947 10.72 7.87671 10.48 8.06147 10.29C8.24623 10.1 8.47962 10 8.7519 10C9.02418 10 9.25757 10.1 9.44233 10.29C9.62709 10.48 9.72433 10.72 9.72433 11C9.72433 11.28 9.62709 11.52 9.44233 11.71C9.25757 11.9 9.02418 12 8.7519 12ZM4.86217 12C4.58989 12 4.3565 11.9 4.17174 11.71C3.98698 11.52 3.88973 11.28 3.88973 11C3.88973 10.72 3.98698 10.48 4.17174 10.29C4.3565 10.1 4.58989 10 4.86217 10C5.13445 10 5.36783 10.1 5.55259 10.29C5.73736 10.48 5.8346 10.72 5.8346 11C5.8346 11.28 5.73736 11.52 5.55259 11.71C5.36783 11.9 5.13445 12 4.86217 12ZM12.6416 12C12.3694 12 12.136 11.9 11.9512 11.71C11.7664 11.52 11.6692 11.28 11.6692 11C11.6692 10.72 11.7664 10.48 11.9512 10.29C12.136 10.1 12.3694 10 12.6416 10C12.9139 10 13.1473 10.1 13.3321 10.29C13.5168 10.48 13.6141 10.72 13.6141 11C13.6141 11.28 13.5168 11.52 13.3321 11.71C13.1473 11.9 12.9139 12 12.6416 12ZM8.7519 16C8.47962 16 8.24623 15.9 8.06147 15.71C7.87671 15.52 7.77947 15.28 7.77947 15C7.77947 14.72 7.87671 14.48 8.06147 14.29C8.24623 14.1 8.47962 14 8.7519 14C9.02418 14 9.25757 14.1 9.44233 14.29C9.62709 14.48 9.72433 14.72 9.72433 15C9.72433 15.28 9.62709 15.52 9.44233 15.71C9.25757 15.9 9.02418 16 8.7519 16ZM4.86217 16C4.58989 16 4.3565 15.9 4.17174 15.71C3.98698 15.52 3.88973 15.28 3.88973 15C3.88973 14.72 3.98698 14.48 4.17174 14.29C4.3565 14.1 4.58989 14 4.86217 14C5.13445 14 5.36783 14.1 5.55259 14.29C5.73736 14.48 5.8346 14.72 5.8346 15C5.8346 15.28 5.73736 15.52 5.55259 15.71C5.36783 15.9 5.13445 16 4.86217 16ZM12.6416 16C12.3694 16 12.136 15.9 11.9512 15.71C11.7664 15.52 11.6692 15.28 11.6692 15C11.6692 14.72 11.7664 14.48 11.9512 14.29C12.136 14.1 12.3694 14 12.6416 14C12.9139 14 13.1473 14.1 13.3321 14.29C13.5168 14.48 13.6141 14.72 13.6141 15C13.6141 15.28 13.5168 15.52 13.3321 15.71C13.1473 15.9 12.9139 16 12.6416 16Z"
        fill="#3A3A3A"
      />
    </svg>
  ),
  svg2: (
    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.42812 11L0 7.58545L3.42812 4.17089L4.20221 4.95661L2.11585 7.03471H7.48289V8.13618H2.11585L4.20221 10.2143L3.42812 11ZM10.5719 6.82911L9.79779 6.04339L11.8842 3.96529H6.51711V2.86382H11.8842L9.79779 0.785714L10.5719 0L14 3.41455L10.5719 6.82911Z"
        fill="#C35379"
      />
    </svg>
  ),
  svg3: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5876 9.36214C11.3898 9.36214 12.1668 9.20435 12.8975 8.89648C13.056 8.82913 13.2396 8.86569 13.3614 8.98692C13.4831 9.10814 13.5179 9.29094 13.4503 9.44681C12.3872 11.9367 9.94584 13.5454 7.22811 13.5454C3.50137 13.5454 0.4705 10.5282 0.4705 6.81834C0.4705 4.1129 2.08645 1.68263 4.58769 0.624317C4.7462 0.55697 4.92983 0.59353 5.04967 0.712831C5.17145 0.834056 5.20624 1.01686 5.13859 1.17464C4.82738 1.90391 4.67081 2.67745 4.67081 3.47407C4.67081 6.7202 7.32476 9.36214 10.5857 9.36214H10.5876ZM3.82998 3.47407C3.82998 2.92759 3.8957 2.38881 4.02327 1.86735C2.35127 2.93914 1.31327 4.79022 1.31327 6.81834C1.31327 10.0645 3.96722 12.7064 7.22811 12.7064C9.26544 12.7064 11.1249 11.675 12.2016 10.0087C11.6778 10.1376 11.1365 10.2011 10.5876 10.2011C6.86085 10.2011 3.82998 7.18394 3.82998 3.47407Z"
        fill="#3A3A3A"
      />
    </svg>
  ),
  svg4: (
    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.14866 1.46556H6.1411C6.22843 1.46556 6.30846 1.49359 6.37428 1.53879C8.44831 2.39649 10.0828 4.26503 11.1069 6.94619M5.14866 1.46556L11.9986 10.823L12.0485 10.8187C12.0418 10.7429 11.8836 8.97863 11.1069 6.94619M5.14866 1.46556V1.34941C5.14866 1.12776 4.96518 0.95 4.74125 0.95C4.51731 0.95 4.33384 1.12776 4.33384 1.34941V11.8424H1.35695C1.21043 11.8424 1.0745 11.9195 1.00229 12.0457C0.930097 12.1718 0.932759 12.3262 1.00965 12.4498L1.00969 12.4498L2.51349 14.8592C2.51349 14.8592 2.51349 14.8592 2.51349 14.8592C2.58764 14.978 2.71948 15.05 2.86076 15.05H9.23923C9.37325 15.05 9.49899 14.9852 9.57507 14.8769L9.57512 14.8768L11.2605 12.4674C11.2605 12.4674 11.2605 12.4674 11.2606 12.4674C11.3461 12.3453 11.3555 12.1862 11.2846 12.0553M5.14866 1.46556L11.2846 12.0553M11.1069 6.94619L11.0601 6.96403L11.1069 6.94618C11.1069 6.94619 11.1069 6.94619 11.1069 6.94619ZM11.2846 12.0553C11.2846 12.0553 11.2846 12.0553 11.2846 12.0553L11.2406 12.0791L11.2846 12.0552C11.2846 12.0553 11.2846 12.0553 11.2846 12.0553ZM5.09807 11.2015H5.14807V11.2515H5.09807V11.2015ZM5.14807 11.8429H5.09807V11.8929H5.14807V11.8429ZM10.9402 9.19874C11.0626 9.71785 11.1383 10.1542 11.1827 10.4527H6.5269V9.18727V2.4888C8.73307 3.62665 9.92705 5.93689 10.5607 7.8527L10.5607 7.85272C10.7207 8.33586 10.8447 8.7923 10.9402 9.1987L10.9402 9.19874ZM5.14924 2.26439H5.71325V10.4527H5.14924V2.26439ZM3.08881 14.2517L2.08364 12.6406H10.153L9.02573 14.2517H3.08881Z"
        fill="#3A3A3A"
        stroke="#3A3A3A"
        stroke-width="0.1"
      />
    </svg>
  ),
  svg5: (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.2308 11.8942L8.49998 1.44232V11.8942H1.2308ZM4.0942 10.3942H7.00003V6.22108L4.0942 10.3942ZM10.5962 11.8942C10.7834 11.4147 10.9808 10.6189 11.1885 9.50668C11.3962 8.39451 11.5 7.27368 11.5 6.1442C11.5 4.96343 11.3987 3.79581 11.1962 2.64133C10.9936 1.48684 10.7968 0.6064 10.6058 0C11.5904 0.376933 12.5468 0.960909 13.475 1.75193C14.4032 2.54294 15.2314 3.46826 15.9596 4.52787C16.6878 5.58749 17.282 6.74678 17.7423 8.00575C18.2026 9.26472 18.4519 10.5609 18.4904 11.8942H10.5962ZM12.5519 10.3942H16.8289C16.5648 8.93139 16.0638 7.57849 15.326 6.33553C14.5881 5.09256 13.7391 4.04158 12.7788 3.1826C12.8442 3.65442 12.8974 4.14353 12.9385 4.64995C12.9795 5.15637 13 5.65445 13 6.1442C13 6.91472 12.9577 7.65895 12.873 8.3769C12.7884 9.09485 12.6814 9.76729 12.5519 10.3942ZM6.75 17.7019C6.18847 17.7019 5.64937 17.5827 5.1327 17.3442C4.61603 17.1058 4.15513 16.7699 3.75 16.3365C3.55513 16.5416 3.34103 16.7381 3.1077 16.9259C2.87437 17.1138 2.62629 17.2615 2.36348 17.3692C1.80579 16.9487 1.33079 16.44 0.938475 15.8432C0.546175 15.2464 0.259 14.5968 0.0769501 13.8942H19.423C19.241 14.5968 18.9538 15.2464 18.5615 15.8432C18.1692 16.44 17.6942 16.9487 17.1365 17.3692C16.8737 17.2615 16.6256 17.1138 16.3923 16.9259C16.159 16.7381 15.9449 16.5416 15.75 16.3365C15.3346 16.7699 14.8711 17.1058 14.3596 17.3442C13.8481 17.5827 13.3115 17.7019 12.75 17.7019C12.1885 17.7019 11.6478 17.5827 11.1279 17.3442C10.608 17.1058 10.1487 16.7666 9.75 16.3269C9.35128 16.7666 8.89198 17.1058 8.3721 17.3442C7.85223 17.5827 7.31153 17.7019 6.75 17.7019ZM0 21.3942V19.8942H0.75C1.28333 19.8942 1.80257 19.8109 2.3077 19.6442C2.81282 19.4776 3.29358 19.2372 3.75 18.9231C4.21282 19.2372 4.69519 19.475 5.19713 19.6365C5.69904 19.7981 6.21667 19.8788 6.75 19.8788C7.28333 19.8788 7.7984 19.7981 8.2952 19.6365C8.79198 19.475 9.27692 19.2372 9.75 18.9231C10.2128 19.2372 10.6952 19.475 11.1971 19.6365C11.699 19.7981 12.2167 19.8788 12.75 19.8788C13.2833 19.8788 13.8 19.7981 14.3 19.6365C14.8 19.475 15.2833 19.2372 15.75 18.9231C16.2231 19.2372 16.708 19.4776 17.2048 19.6442C17.7016 19.8109 18.2167 19.8942 18.75 19.8942H19.5V21.3942H18.75C18.2526 21.3942 17.7539 21.3301 17.2539 21.2019C16.7539 21.0737 16.2526 20.8782 15.75 20.6153C15.2474 20.8782 14.7462 21.0737 14.2462 21.2019C13.7462 21.3301 13.2474 21.3942 12.75 21.3942C12.2526 21.3942 11.7538 21.3301 11.2538 21.2019C10.7538 21.0737 10.2526 20.8782 9.75 20.6153C9.24743 20.8782 8.74615 21.0737 8.24615 21.2019C7.74615 21.3301 7.24743 21.3942 6.75 21.3942C6.25257 21.3942 5.75385 21.3301 5.25385 21.2019C4.75385 21.0737 4.25257 20.8782 3.75 20.6153C3.24743 20.8782 2.74615 21.0737 2.24615 21.2019C1.74615 21.3301 1.24743 21.3942 0.75 21.3942H0Z"
        fill="#92278F"
      />
    </svg>
  ),
  svg6: (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.2308 11.8942L8.49998 1.44232V11.8942H1.2308ZM4.0942 10.3942H7.00003V6.22108L4.0942 10.3942ZM10.5962 11.8942C10.7834 11.4147 10.9808 10.6189 11.1885 9.50668C11.3962 8.39451 11.5 7.27368 11.5 6.1442C11.5 4.96343 11.3987 3.79581 11.1962 2.64133C10.9936 1.48684 10.7968 0.6064 10.6058 0C11.5904 0.376933 12.5468 0.960909 13.475 1.75193C14.4032 2.54294 15.2314 3.46826 15.9596 4.52787C16.6878 5.58749 17.282 6.74678 17.7423 8.00575C18.2026 9.26472 18.4519 10.5609 18.4904 11.8942H10.5962ZM12.5519 10.3942H16.8289C16.5648 8.93139 16.0638 7.57849 15.326 6.33553C14.5881 5.09256 13.7391 4.04158 12.7788 3.1826C12.8442 3.65442 12.8974 4.14353 12.9385 4.64995C12.9795 5.15637 13 5.65445 13 6.1442C13 6.91472 12.9577 7.65895 12.873 8.3769C12.7884 9.09485 12.6814 9.76729 12.5519 10.3942ZM6.75 17.7019C6.18847 17.7019 5.64937 17.5827 5.1327 17.3442C4.61603 17.1058 4.15513 16.7699 3.75 16.3365C3.55513 16.5416 3.34103 16.7381 3.1077 16.9259C2.87437 17.1138 2.62629 17.2615 2.36348 17.3692C1.80579 16.9487 1.33079 16.44 0.938475 15.8432C0.546175 15.2464 0.259 14.5968 0.0769501 13.8942H19.423C19.241 14.5968 18.9538 15.2464 18.5615 15.8432C18.1692 16.44 17.6942 16.9487 17.1365 17.3692C16.8737 17.2615 16.6256 17.1138 16.3923 16.9259C16.159 16.7381 15.9449 16.5416 15.75 16.3365C15.3346 16.7699 14.8711 17.1058 14.3596 17.3442C13.8481 17.5827 13.3115 17.7019 12.75 17.7019C12.1885 17.7019 11.6478 17.5827 11.1279 17.3442C10.608 17.1058 10.1487 16.7666 9.75 16.3269C9.35128 16.7666 8.89198 17.1058 8.3721 17.3442C7.85223 17.5827 7.31153 17.7019 6.75 17.7019ZM0 21.3942V19.8942H0.75C1.28333 19.8942 1.80257 19.8109 2.3077 19.6442C2.81282 19.4776 3.29358 19.2372 3.75 18.9231C4.21282 19.2372 4.69519 19.475 5.19713 19.6365C5.69904 19.7981 6.21667 19.8788 6.75 19.8788C7.28333 19.8788 7.7984 19.7981 8.2952 19.6365C8.79198 19.475 9.27692 19.2372 9.75 18.9231C10.2128 19.2372 10.6952 19.475 11.1971 19.6365C11.699 19.7981 12.2167 19.8788 12.75 19.8788C13.2833 19.8788 13.8 19.7981 14.3 19.6365C14.8 19.475 15.2833 19.2372 15.75 18.9231C16.2231 19.2372 16.708 19.4776 17.2048 19.6442C17.7016 19.8109 18.2167 19.8942 18.75 19.8942H19.5V21.3942H18.75C18.2526 21.3942 17.7539 21.3301 17.2539 21.2019C16.7539 21.0737 16.2526 20.8782 15.75 20.6153C15.2474 20.8782 14.7462 21.0737 14.2462 21.2019C13.7462 21.3301 13.2474 21.3942 12.75 21.3942C12.2526 21.3942 11.7538 21.3301 11.2538 21.2019C10.7538 21.0737 10.2526 20.8782 9.75 20.6153C9.24743 20.8782 8.74615 21.0737 8.24615 21.2019C7.74615 21.3301 7.24743 21.3942 6.75 21.3942C6.25257 21.3942 5.75385 21.3301 5.25385 21.2019C4.75385 21.0737 4.25257 20.8782 3.75 20.6153C3.24743 20.8782 2.74615 21.0737 2.24615 21.2019C1.74615 21.3301 1.24743 21.3942 0.75 21.3942H0Z"
        fill="#1E8EDF"
      />
    </svg>
  ),
};

const PreviewItineraryModal: React.FC<IPreviewItineraryModal> = (props) => {
  const navigate = useNavigate();
  const snackbarCtx = useContext(SnackbarContext);
  const { previewData, handleSuccessModal, handleDetailsModal, setStepNumber } = props;
  const { selectedUser, existingEnquiry } = useContext(SelectedUserContext);
  const [itineraryIdsArr, setItineraryIdsArr] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const handleSelectedCards = async (e: any, id: string) => {
    if (e.target.checked) {
      setItineraryIdsArr([...itineraryIdsArr, id]);
    } else {
      const tempArr = itineraryIdsArr.filter((itineraryId: string) => itineraryId !== id)
      setItineraryIdsArr([...tempArr]);
    }
  }

  const handleBuildQuotation = async() => {
    const response = await manageItineraryEnquiry(existingEnquiry?.id, { itineraryIds: itineraryIdsArr });
    if (response.status === 201) {
      navigate(`/add-leads/3/${selectedUser?.id}`);
      setStepNumber(3);
      handleDetailsModal();
    } else {
      snackbarCtx.toggleSnackbar({
        message: 'Something went wrong !',
        type: 'FAILURE',
        visible: true,
        });
    }
  }

  const handleEmailTrigger = async () => {
    setLoading(true)
    const data = await manageItineraryEnquiry(existingEnquiry?.id, { itineraryIds: itineraryIdsArr });
    if (data?.status === 201) {
      const emailRes = await sendItineraryEmail(existingEnquiry?.id);
      if (emailRes?.status === 200) {
        handleSuccessModal();
        handleDetailsModal();
      }
    }
    setLoading(false)
  }

  const handleTripType = (tripType: string) => {
    return tripType?.includes('one') ? 'One Way Trip' : 'Round Trip';
  }

  const formatTimeSimple = (timeString: string) => {
    let [time, modifier] = timeString.split(" ");
    let [hours, minutes] = time.split(":");
    hours = hours.padStart(2, "0");
    return `${hours}:${minutes} ${modifier}`;
  };

  useEffect(() => { 
    if (previewData?.length === 1) {
      const id: string = previewData[0]?.details.id;
      setItineraryIdsArr([id]);
    }
  }, [previewData])

  return (
    <div className="preview-itinerary-modal-wrapper flex flex-col gap-4">
      <span className="heading-text text-uppercase">Preview Itinerary</span>
      <div className="guest-details-wrapper flex gap-20 mr-2">
        <div className="flex flex-col gap-2">
          <span className="detail-name">Guest Name</span>
          <span>{selectedUser.firstName + ' ' + selectedUser.lastName}</span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="detail-name">Contact</span>
          <span>{selectedUser.phoneNumber}</span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="detail-name">Whatsapp</span>
          <span>{selectedUser.whatsappNumber}</span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="detail-name">Email</span>
          <span>{selectedUser.email}</span>
        </div>
      </div>
      <div className="flex flex-col gap-3 pr-2 itinerary-details-cards-wrapper">
        {previewData?.map((itineraryData: any, index: number) => {
          return (
            <div key={index} className="itinerary-details-card-wrapper py-3 px-3">
              <div className="itinerary-name px-2 pb-3.5">
                <input type="checkbox" id={`${index}`} checked={previewData?.length === 1 ? true : itineraryIdsArr?.includes(itineraryData?.details?.id)} onChange={previewData?.length === 1 ? () => {} : (e) => handleSelectedCards(e, itineraryData?.details?.id)} />
                <label htmlFor={`${index}`} className="flex items-center text-uppercase">
                  {itineraryData?.details?.route}
                </label>
              </div>
              <div className="itinerary-duration flex gap-5 px-2 py-3">
                  <span>
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="trip-type">{handleTripType(itineraryData?.details?.trip_type)}</span>
                  {svgFiles.svg2}
                  {svgFiles.svg1}
                    {dayjs(splitDate(itineraryData?.details?.start_time)).format("DD MMM YYYY")} - {dayjs(splitDate(itineraryData?.details?.end_time)).format("DD MMM YYYY")}
                <div className="flex items-center gap-2.5">
                </div>
                <div className="flex items-center gap-2">
                  {svgFiles.svg3}
                  <span>{itineraryData?.details?.night_count} Nights</span>
                </div>
                <div className="flex items-center gap-2">
                  {svgFiles.svg4}
                  <span className="text-capitalize">{itineraryData?.details?.ship_name?.toLowerCase()}</span>
                </div>
              </div>
              <div className="itinerary-transit flex flex-wrap gap-4 px-2 py-4">
                {itineraryData?.port_seq?.map((transit: any, index: number) => {
                  return (
                    <>
                      <div key={index} className="flex flex-col gap-1">
                        <div className="flex gap-1.5">
                          {transit?.name.includes("Sea") ? svgFiles.svg6 : svgFiles.svg5}
                          <span className={`${transit?.name.includes("Sea") ? "blue" : "purple"}`}>
                            {transit?.name}
                          </span>
                        </div>
                        {transit?.departure_time && (
                          <div className="flex flex-col">
                            <span className="transit-date">{dayjs(splitDate(transit?.departure_time)).format("DD MMM YYYY")}</span>
                            <span>
                              {index === 0 ? (
                                <span className="transit-time">
                                  {new Date(transit?.departure_time).toLocaleTimeString("en-US", {
                                    hour: "numeric",
                                    minute: "numeric",
                                    hour12: true,
                                    })}
                                </span>
                              ) : (
                                <span className="transit-time">
                                  {transit?.arrival_time
                                    ? new Date(transit?.arrival_time).toLocaleTimeString("en-US", {
                                      hour: "numeric",
                                      minute: "numeric",
                                      hour12: true,
                                     })
                                    : " "}
                                </span>
                              )}
                            </span>
                          </div>
                        )}
                      </div>
                      {itineraryData?.port_seq?.length !== index + 1 && <div className="strike-div">━━━</div>}
                    </>
                  );
                })}
              </div>
              <div className="itinerary-cabins flex flex-col gap-2.5 px-2 pt-3.5">
                <span className="cabins-heading">Available Cabins</span>
                {!itineraryData?.rooms?.length ? (
                  <span className="no-cabins">No Cabins Available</span>
                ) : (
                  <div className="flex flex-wrap gap-5">
                    {itineraryData?.rooms?.map((cabin: any, index: number) => {
                      return (
                        <div key={index} className="flex flex-col gap-1 min-w-[200px]">
                          <span className="cabin-name text-muted">{cabin?.category}</span>
                          <span className={`${cabin?.room_count <= 10 ? "red" : "green"}`}>
                            {cabin?.room_count <= 10 ? "Less Than 10 Cabins" : "More Than 10 Cabins"}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          );
        })}
        {/* <div className="flex gap-2 details-checkbox self-end">
          <div>
            <input type="checkbox" id="ship-details" onChange={() => {}} />
            <label htmlFor="ship-details" className="flex items-center">
              Ship Details
            </label>
          </div>
          <div>
            <input type="checkbox" id="itinerary-details" onChange={() => {}} />
            <label htmlFor="itinerary-details" className="flex items-center">
              Itinerary Details
            </label>
          </div>
        </div> */}
        {/* <div className="flex justify-between gap-2">
          <CustomButton fillColor={false}>Edit</CustomButton> */}
        {/* </div> */}
      </div>
      <div className="flex gap-3 self-end">
        <CustomButton onButtonClick={handleEmailTrigger} disabled={!itineraryIdsArr.length || loading}>
          {loading && <Spinner animation="border" size="sm" className="mr-3" />}
          Send Itinerary </CustomButton>
        <CustomButton onButtonClick={handleBuildQuotation} disabled={!itineraryIdsArr.length || loading}>Build Quotation</CustomButton>
      </div>
    </div>
  );
};

export default PreviewItineraryModal;
